export const getIsIframe = (): boolean => {
  return window.self !== window.top
}
